import React from 'react';
import { Button } from './ui/Button';
import { CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  const handleScrollToPricing = () => {
    window.location.href = 'https://checkout.recursostop.shop/cart/45775377465540:1';
  };
  return <section className="pt-20 pb-12 md:pt-28 md:pb-20 bg-gradient-to-b from-[#FDF4FF] to-[#FFF0F5] text-center px-4 overflow-hidden" data-id="element-106">
      <div className="max-w-5xl mx-auto" data-id="element-107">
        <div className="mb-6 inline-block bg-purple-100 border-2 border-purple-300 text-purple-800 px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider animate-pulse" data-id="element-108">
          ✨ Para personas que quieren generar ingresos extras y emprender
        </div>

        <h1 className="text-4xl md:text-6xl font-black leading-tight mb-6 tracking-tight" data-id="element-109">
          <span className="gold-title" data-id="element-110">MegaPack</span>{' '}
          <span className="text-gray-900" data-id="element-111">Estética Integral</span>
        </h1>

        <p className="text-xl md:text-2xl text-gray-600 mb-10 max-w-3xl mx-auto font-medium" data-id="element-112">
          La formación digital completa que te enseña{' '}
          <span className="font-bold text-gray-900 bg-purple-200 px-1" data-id="element-113">
            6 especialidades reales, prácticas y rentables
          </span>
          , con 3 bonos estratégicos para diferenciarte.
        </p>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center mb-12 text-left" data-id="element-114">
          <div className="relative group cursor-pointer" onClick={handleScrollToPricing} data-id="element-115">
            <div className="absolute -inset-1 bg-gradient-to-r from-purple-300 to-pink-400 rounded-lg blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200" data-id="element-116"></div>
            <img src="https://cdn.magicpatterns.com/uploads/9gpGP9RLcGsUmCzexXBmTm/ChatGPT_Image_13_feb_2026,_20_00_27.png" alt="MegaPack Estética Integral - 6 Guías para Emprender" className="relative rounded-lg shadow-2xl w-full h-auto" data-id="element-117" />
          </div>

          <div className="space-y-6" data-id="element-118">
            <div className="space-y-4" data-id="element-119">
              <div className="flex items-start" data-id="element-120">
                <CheckCircle2 className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-121" />
                <p className="text-lg text-gray-700" data-id="element-122">
                  Todo en formato eBook. Claro. Estructurado.
                </p>
              </div>
              <div className="flex items-start" data-id="element-123">
                <CheckCircle2 className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-124" />
                <p className="text-lg text-gray-700" data-id="element-125">
                  Listo para aplicar. Sin relleno.
                </p>
              </div>
              <div className="flex items-start" data-id="element-126">
                <CheckCircle2 className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-127" />
                <p className="text-lg text-gray-700" data-id="element-128">
                  Sin teoría inútil. Directo al grano.
                </p>
              </div>
            </div>

            <div className="pt-4" data-id="element-129">
              <Button onClick={handleScrollToPricing} size="xl" fullWidth className="animate-bounce" data-id="element-130">
                👉 SÍ, QUIERO ACCEDER AHORA
              </Button>
              <p className="text-center text-sm text-gray-500 mt-3 flex items-center justify-center gap-2" data-id="element-131">
                <span className="w-2 h-2 bg-green-500 rounded-full" data-id="element-132"></span>✅
                Garantía de satisfacción de 7 días
              </p>
              <div className="flex items-center justify-center gap-4 mt-4 opacity-70" data-id="element-133">
                <img src="https://cdn.magicpatterns.com/uploads/fL9kACheWktd2dhJwcnkzQ/mercado_pago.jpg" alt="Mercado Pago" className="h-8 rounded" data-id="element-134" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}